<template>
  <p
    :class="[
      'text-paragraph',
      textAlignClass,
      `text-${textColor}`,
      { 'text-uppercase': !noCaps }
    ]"
  >
    <slot />
  </p>
</template>

<script>
export default {
  name: 'SAITagline',
  props: {
    textColor: {
      type: String,
      default: 'grey-6'
    },
    textAlign: {
      type: String,
      default: 'center'
    },
    noCaps: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textAlignClass() {
      return this.textAlign ? `text-${this.textAlign}` : '';
    }
  }
};
</script>
